export default __webpack_public_path__ + "static/media/map.016b4dfc.jpg";